import React, { Component, PropsWithChildren, ReactNode } from "react";
import LoadingOverlay from "../../components/LoadingOverlay";
import Loader from "../../components/Loader";

type ErrorBoundaryProps = {
  children: ReactNode | Array<ReactNode>;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch() {
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong</h1>;
    }
    return this.props.children;
  }
}

type LoadingAndErrorHandlingProps = {
  error?: unknown;
  loading?: boolean;
  displayChildrenWhileLoading?: boolean;
  useFullscreenLoader?: boolean;
};

const LoadingAndErrorHandling: React.FC<
  PropsWithChildren<LoadingAndErrorHandlingProps>
> = ({
  error,
  loading = false,
  children,
  displayChildrenWhileLoading = false,
  useFullscreenLoader = false
}) => {
  const hasError = !!error;

  return (
    <ErrorBoundary>
      {hasError && error.toString()}
      {!hasError && loading && useFullscreenLoader && <Loader />}
      {!hasError && loading && !useFullscreenLoader && <LoadingOverlay />}
      {!hasError && (!loading || displayChildrenWhileLoading) && children}
    </ErrorBoundary>
  );
};

export { ErrorBoundary };
export default LoadingAndErrorHandling;
